
function ClearCartPopup(variables){
  const popup = document.createElement('div');
  popup.classList.add('Popup');
  popup.classList.add('CartPopup');

  const Template = {
    icon: `<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.61362 23.8065C11.7521 21.9814 14.3349 21.1242 16.895 21.0126L17.485 21H17.8217H19.037L18.803 19.8074C18.7694 19.636 18.7694 19.4613 18.803 19.2898L18.8172 19.2175L18.8206 19.1438C19.2885 9.0964 28.5474 1 40.022 1C51.0953 1 60.1052 8.54011 61.1423 18.0973H61.0601L61.1071 19.1422C61.1133 19.2792 61.0845 19.4195 61.0175 19.554L60.297 21H61.9125H62.6065C67.5393 21 72.8252 24.0476 74.9844 31.7778L75.2144 32.6736L78.6239 57.3956L78.6251 57.4041L78.6264 57.4127C79.8209 65.089 78.0668 70.345 74.6232 73.7329C71.1427 77.1571 65.758 78.8521 59.345 78.9907C59.3431 78.9908 59.3413 78.9908 59.3394 78.9909L58.4821 79H58.4765H21.6379C15.0376 79 9.4409 77.9072 5.77031 74.882C2.17988 71.923 0.203296 66.9103 1.30316 58.4697L1.45616 57.4006L1.45665 57.3971L4.90953 32.6451C5.72735 28.4619 7.48185 25.6258 9.61362 23.8065ZM32.0257 36.9557V36.9222L32.0235 36.8888L31.9929 36.4324L31.9906 36.3988L31.9861 36.3654C31.6699 34.0247 29.5479 32.3172 27.0978 32.3172C24.4496 32.3172 22.1698 34.3232 22.1698 36.9557C22.1698 39.5882 24.4496 41.5943 27.0978 41.5943C29.746 41.5943 32.0257 39.5882 32.0257 36.9557ZM23.3637 19.0973V19.1945L23.3824 19.2898C23.4161 19.4613 23.4161 19.636 23.3824 19.8074L23.1484 21H24.3637H55.5254H57.0427L56.4443 19.6056C56.3723 19.4377 56.335 19.2632 56.3318 19.0893C56.327 10.7712 48.8437 4.20954 39.8478 4.20954C30.849 4.20954 23.3637 10.7755 23.3637 19.0973ZM52.8259 32.3172C50.1777 32.3172 47.8979 34.3232 47.8979 36.9557C47.8979 39.5882 50.1777 41.5943 52.8259 41.5943C55.474 41.5943 57.7538 39.5882 57.7538 36.9557C57.7538 34.3232 55.474 32.3172 52.8259 32.3172Z" stroke="black" stroke-opacity="0.18" stroke-width="2"/>
</svg>`,
    title: variables.title ? variables.title: null,
    buttoncancel: {
        label: variables.buttoncancel ? variables.buttoncancel: null,
        link: ()=>{popup.remove()}
      },
    buttonclear: {
        label: variables.buttonclear ? variables.buttonclear: null,
        link: 'cart/clear'
      }
  }
  
  const back_overflow = document.createElement('div');
  back_overflow.classList.add('PopupBackOverflou');

  back_overflow.addEventListener('click', ()=>{
    popup.remove();
  })

  popup.append(back_overflow);

  const popup_content = document.createElement('div');
  popup_content.classList.add('PopupContent');

  const popup_content_btn_close = document.createElement('button');
  popup_content_btn_close.classList.add('PopupContentButtonClose');
  popup_content_btn_close.innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"/>
</svg>`;
  popup_content_btn_close.addEventListener('click', ()=>{
    popup.remove();
  })

  popup_content.append(popup_content_btn_close);

  if(Template.icon){
    const popup_content_icon = document.createElement('div');
    popup_content_icon.classList.add('PopupContentIcon');
    popup_content_icon.innerHTML = Template.icon;
    popup_content.append(popup_content_icon);
  }

  if(Template.title){
    const popup_content_title = document.createElement('div');
    popup_content_title.classList.add('PopupContentTitle');
    popup_content_title.innerHTML = Template.title;
    popup_content.append(popup_content_title);
  }

  if(Template.buttoncancel.label || Template.buttonclear.label){
    const popup_content_buttons = document.createElement('div');
    popup_content_buttons.classList.add('PopupContentButtons');

    if(Template.buttoncancel.label){
      if( typeof Template.buttoncancel.link == 'function' ){
        var popup_content_button = document.createElement('button');
        popup_content_button.addEventListener('click', ()=> Template.buttoncancel.link())
      }else{
        var popup_content_button = document.createElement('a');
        popup_content_button.href = Template.buttoncancel.link;
      }
      
      popup_content_button.classList.add('PopupContentButton');
      popup_content_button.classList.add('PopupContentButtonWhite');
      popup_content_button.innerHTML = Template.buttoncancel.label;
      popup_content_buttons.append(popup_content_button);
      }

    if(Template.buttonclear.label){
      if( typeof Template.buttonclear.link == 'function' ){
        var popup_content_button = document.createElement('button');
        popup_content_button.addEventListener('click', ()=> Template.buttonclear.link())
      }else{
        var popup_content_button = document.createElement('a');
        popup_content_button.href = Template.buttonclear.link;
      }
      
      popup_content_button.classList.add('PopupContentButton');
       popup_content_button.classList.add('PopupContentButtonBlack');
      popup_content_button.innerHTML = Template.buttonclear.label;
      popup_content_buttons.append(popup_content_button);
      }
    
    popup_content.append(popup_content_buttons);
  }

  popup.append(popup_content);

  document.body.append(popup);
}

function ChangeItemCartPopup(variables){
  const popup = document.createElement('div');
  popup.classList.add('Popup');
  popup.classList.add('CartPopup');
  popup.classList.add('ChangeItemCartPopup');

  const Template = {
    item: variables.item ? variables.item: null,
    
    buttoncancel: {
        label: variables.buttoncancel ? variables.buttoncancel: null,
        link: ()=>{popup.remove()}
      },
    buttonsave: {
        label: variables.buttonsave ? variables.buttonsave: null,
        link: ()=>{popup.remove()}
      }
  }
  
  const back_overflow = document.createElement('div');
  back_overflow.classList.add('PopupBackOverflou');

  back_overflow.addEventListener('click', ()=>{
    popup.remove();
  })

  popup.append(back_overflow);

  const popup_content = document.createElement('div');
  popup_content.classList.add('PopupContent');

  const popup_content_btn_close = document.createElement('button');
  popup_content_btn_close.classList.add('PopupContentButtonClose');
  popup_content_btn_close.innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"/>
</svg>`;
  popup_content_btn_close.addEventListener('click', ()=>{
    popup.remove();
  })

  popup_content.append(popup_content_btn_close);

  const popup_content_top = document.createElement('div');
  popup_content_top.classList.add('PopupContentTop');

  if(Template.item.image_url){
    const popup_content_top_image = document.createElement('div');
    popup_content_top_image.classList.add('PopupContentTopImage');
    popup_content_top_image.innerHTML = `<img src="`+Template.item.image_url+`" >`;
    popup_content_top.append(popup_content_top_image);
  }

  if(Template.item.title){
    const popup_content_top_title = document.createElement('div');
    popup_content_top_title.classList.add('PopupContentTopTitle');
    popup_content_top_title.innerHTML = Template.item.title;
    popup_content_top.append(popup_content_top_title);
  }

  popup_content.append(popup_content_top);

  let popup_content_lenght_input = null;
  let popup_content_quantity_input = null;

  if(Template.item.fabric == "true"){
    const popup_content_lenght = document.createElement('div');
    popup_content_lenght.classList.add('PopupContentLenght');

    popup_content_lenght_btn_minus = document.createElement('button');
    popup_content_lenght_btn_minus.classList.add('PopupContentLenghtButton');
    popup_content_lenght_btn_minus.classList.add('PopupContentLenghtButtonMinus');
    popup_content_lenght_btn_minus.innerHTML = `<svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.875" width="34" height="30" rx="10" fill="#EAECF2"/>
    <line x1="7.875" y1="14.5" x2="27.875" y2="14.5" stroke="black"/>
    </svg>`;

    popup_content_lenght_btn_plus = document.createElement('button');
    popup_content_lenght_btn_plus.classList.add('PopupContentLenghtButton');
    popup_content_lenght_btn_plus.classList.add('PopupContentLenghtButtonPlus');
    popup_content_lenght_btn_plus.innerHTML = `<svg width="41" height="30" viewBox="0 0 41 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.125" width="40" height="30" rx="10" fill="#EAECF2"/>
    <line x1="10.125" y1="14.5" x2="30.125" y2="14.5" stroke="black"/>
    <line x1="20.625" y1="5" x2="20.625" y2="24.5" stroke="black"/>
    </svg>`;

    popup_content_lenght_input_block = document.createElement('div');
    popup_content_lenght_input_block.classList.add('PopupContentLenghtInput');

    popup_content_lenght_input_curency = document.createElement('div');
    popup_content_lenght_input_curency.classList.add('PopupContentLenghtInputCurrency');
    popup_content_lenght_input_curency.innerHTML="М";
    
    popup_content_lenght_input = document.createElement('input');
    //popup_content_lenght_input.classList.add('PopupContentLenghtInput');
    popup_content_lenght_input.type = 'number';
    popup_content_lenght_input.step = 0.5;
    popup_content_lenght_input.min = 0.5;
    popup_content_lenght_input.max = Number(Template.item.available_length);
    popup_content_lenght_input.value = Number(Template.item.length);

    if(popup_content_lenght_input.max == 0){
      popup_content_lenght_input.max = 100;
    }

    popup_content_lenght_btn_minus.addEventListener('click', ()=>{
      if(Number(popup_content_lenght_input.value) - Number(popup_content_lenght_input.step) >= Number(popup_content_lenght_input.min)){
        popup_content_lenght_input.value = Number(popup_content_lenght_input.value) - Number(popup_content_lenght_input.step)
      }else{
        popup_content_lenght_input.value = Number(popup_content_lenght_input.min);
      }
       popup_content_lenght_input.value = Number(roundToHalf(popup_content_lenght_input.value)).toFixed(2)
    })

    popup_content_lenght_btn_plus.addEventListener('click', ()=>{
      if(Number(popup_content_lenght_input.value) + Number(popup_content_lenght_input.step) <= Number(popup_content_lenght_input.max)){
        popup_content_lenght_input.value = Number(popup_content_lenght_input.value) + Number(popup_content_lenght_input.step)
      }else{
        popup_content_lenght_input.value = Number(popup_content_lenght_input.max);
      }
       popup_content_lenght_input.value = Number(roundToHalf(popup_content_lenght_input.value)).toFixed(2)
    })

    popup_content_lenght_input.addEventListener('change', ()=>{
      if(Number(popup_content_lenght_input.value) <= Number(popup_content_lenght_input.min)){
        popup_content_lenght_input.value = Number(popup_content_lenght_input.min);
      }
      if(Number(popup_content_lenght_input.value) >= Number(popup_content_lenght_input.max)){
        popup_content_lenght_input.value = Number(popup_content_lenght_input.max);
      }
      popup_content_lenght_input.value = Number(roundToHalf(popup_content_lenght_input.value)).toFixed(2)
    })
    
    popup_content_lenght.append(popup_content_lenght_btn_minus);
    
    popup_content_lenght_input_block.append(popup_content_lenght_input);
    popup_content_lenght_input_block.append(popup_content_lenght_input_curency);
    popup_content_lenght.append(popup_content_lenght_input_block);
    popup_content_lenght.append(popup_content_lenght_btn_plus);

    popup_content.append(popup_content_lenght);

    if(Boolean(Template.item.fromorder)){
      if(Template.item.available_length){
        const popup_available_length = document.createElement('div');
        popup_available_length.classList.add('PopupContentAvailableLenght');
        popup_available_length.innerHTML = Template.item.fromorder + ' ' + Template.item.available_length + ' м.';
        popup_content.append(popup_available_length);
      }
    }
    

    
    
  }else{
    const popup_content_quantity = document.createElement('div');
    popup_content_quantity.classList.add('PopupContentQuantity');

    popup_content_quantity_btn_minus = document.createElement('div');
    popup_content_quantity_btn_minus.classList.add('PopupContentQuantityButton');
    popup_content_quantity_btn_minus.classList.add('PopupContentQuantityButtonMinus');
    popup_content_quantity_btn_minus.innerHTML = `<svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.875" width="34" height="30" rx="10" fill="#EAECF2"/>
    <line x1="7.875" y1="14.5" x2="27.875" y2="14.5" stroke="black"/>
    </svg>`;

    popup_content_quantity_btn_plus = document.createElement('div');
    popup_content_quantity_btn_plus.classList.add('PopupContentQuantityButton');
    popup_content_quantity_btn_plus.classList.add('PopupContentQuantityButtonPlus');
    popup_content_quantity_btn_plus.innerHTML = `<svg width="41" height="30" viewBox="0 0 41 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.125" width="40" height="30" rx="10" fill="#EAECF2"/>
    <line x1="10.125" y1="14.5" x2="30.125" y2="14.5" stroke="black"/>
    <line x1="20.625" y1="5" x2="20.625" y2="24.5" stroke="black"/>
    </svg>`;


    popup_content_quantity_input = document.createElement('input');
    popup_content_quantity_btn_plus.classList.add('PopupContentQuantityInput');
    popup_content_quantity_input.type = 'number';
    popup_content_quantity_input.step = 1;
    popup_content_quantity_input.min = 1;
    if(Template.item.inventory_management !== 'null' && Template.item.inventory_policy !== 'continue'){
      popup_content_quantity_input.max = Number(Template.item.inventory_quantity);
    }
    popup_content_quantity_input.value = Number(Template.item.quantity);

    popup_content_quantity_btn_minus.addEventListener('click', ()=>{
      if(Number(popup_content_quantity_input.value) - Number(popup_content_quantity_input.step) >= Number(popup_content_quantity_input.min)){
        popup_content_quantity_input.value = Number(popup_content_quantity_input.value) - Number(popup_content_quantity_input.step)
      }else{
        popup_content_quantity_input.value = Number(popup_content_quantity_input.min);
      }
    })

    popup_content_quantity_btn_plus.addEventListener('click', ()=>{
      if(Boolean(popup_content_quantity_input.max)){
        if(Number(popup_content_quantity_input.value) + Number(popup_content_quantity_input.step) <= Number(popup_content_quantity_input.max)){
          popup_content_quantity_input.value = Number(popup_content_quantity_input.value) + Number(popup_content_quantity_input.step)
        }else{
          popup_content_quantity_input.value = Number(popup_content_quantity_input.max);
        }
      }else{
        popup_content_quantity_input.value = Number(popup_content_quantity_input.value) + Number(popup_content_quantity_input.step);
      }
    })

    popup_content_quantity_input.addEventListener('change', ()=>{
      if(Number(popup_content_quantity_input.value) <= Number(popup_content_quantity_input.min)){
        popup_content_quantity_input.value = Number(popup_content_quantity_input.min);
      }
      if(Boolean(popup_content_quantity_input.max)){
      if(Number(popup_content_quantity_input.value) >= Number(popup_content_quantity_input.max)){
        popup_content_quantity_input.value = Number(popup_content_quantity_input.max);
      }
      }
      popup_content_quantity_input.value = Math.floor(Number(popup_content_quantity_input.value));
    })
    
    popup_content_quantity.append(popup_content_quantity_btn_minus);
    popup_content_quantity.append(popup_content_quantity_input);
    popup_content_quantity.append(popup_content_quantity_btn_plus);

    popup_content.append(popup_content_quantity);
  }


  

  if(Boolean(Template.buttonsave?.label) || Boolean(Template.buttoncancel?.label)){
    const popup_content_buttons = document.createElement('div');
    popup_content_buttons.classList.add('PopupContentButtons');
    popup_content_buttons.classList.add('PopupContentButtonsCollumn');

    if(Boolean(Template.buttonsave?.label)){
      var popup_content_button = document.createElement('button');
      
      popup_content_button.addEventListener('click', async function(elem) {

        elem.target.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24">
        <path fill="#fff" d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" stroke-width="1.75">
        <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"></animateTransform>
        </path>
        </svg>`;
        
        if(popup_content_lenght_input !== null && Boolean(popup_content_lenght_input.value)){
          if(Number(popup_content_lenght_input.value) !== Number(Template.item.length)){
             variables.item.properties['_length'] = popup_content_lenght_input.value;
            
             await AddToCart(Template.item.id, 1, popup_content_lenght_input.value, variables.item.properties, 'false');
             const updates = {};
             updates[Number(Template.item.id)] = 0; 
             await AppdateCart(updates);
          }
        }else{
          const updates = {};
          updates[Number(Template.item.id)] = popup_content_quantity_input.value;
          await AppdateCart(updates);
        }

        popup.remove();
      })

      
      
      popup_content_button.classList.add('PopupContentButton');
      popup_content_button.classList.add('PopupContentButtonBlack');
      popup_content_button.innerHTML = Template.buttonsave.label;
      popup_content_buttons.append(popup_content_button);
      }

    if(Boolean(Template.buttoncancel?.label)){
      if( typeof Template.buttoncancel.link == 'function' ){
        var popup_content_button = document.createElement('button');
        popup_content_button.addEventListener('click', ()=> Template.buttoncancel.link())
      }else{
        var popup_content_button = document.createElement('a');
        popup_content_button.href = Template.buttoncancel.link;
      }
      
      popup_content_button.classList.add('PopupContentButton');
      popup_content_button.classList.add('PopupContentButtonWhite');
      popup_content_button.innerHTML = Template.buttoncancel.label;
      popup_content_buttons.append(popup_content_button);
      }
    
    popup_content.append(popup_content_buttons);
  }

  popup.append(popup_content);

  document.body.append(popup);
}

function CartInit(){
  document.querySelectorAll('[cart-clear-btn]').forEach((elem)=>{
    elem.addEventListener('click', ()=>{
      let variables = {};
      if(Boolean(elem.dataset.popupTitle)){
        variables.title = elem.dataset.popupTitle
      }
      if(Boolean(elem.dataset.popupButtoncancel)){
        variables.buttoncancel = elem.dataset.popupButtoncancel
      }
      if(Boolean(elem.dataset.popupButtonclear)){
        variables.buttonclear = elem.dataset.popupButtonclear
      }
      ClearCartPopup(variables)
    })
  });

  document.querySelectorAll('[cart-item-open-change]').forEach((elem)=>{
    elem.addEventListener('click', ()=>{
      let variables = {};
      
      if(Boolean(elem.dataset.popupButtoncancel)){
        variables.buttoncancel = elem.dataset.popupButtoncancel
      }

      if(Boolean(elem.dataset.popupButtonsave)){
        variables.buttonsave = elem.dataset.popupButtonsave
      }

      variables.item = {
        id: elem.dataset.popupVariantId ? elem.dataset.popupVariantId : null,
        title: elem.dataset.popupItemTitle ? elem.dataset.popupItemTitle : null,
        image_url: elem.dataset.popupItemImage ? elem.dataset.popupItemImage : null,
        length: elem.dataset.popupItemLength ? elem.dataset.popupItemLength : null,
        available_length: elem.dataset.popupItemAvailableLength ? Number(elem.dataset.popupItemAvailableLength) : null,
        quantity: elem.dataset.popupItemQuantity ? elem.dataset.popupItemQuantity : 1,
        inventory_quantity: elem.dataset.popupItemAvailableInventoryQuantity ? elem.dataset.popupItemAvailableInventoryQuantity : 1,
        inventory_management: elem.dataset.popupItemAvailableInventoryManagement ? elem.dataset.popupItemAvailableInventoryManagement : 'null',
        inventory_policy: elem.dataset.popupItemAvailableInventoryPolicy ? elem.dataset.popupItemAvailableInventoryPolicy : 'null',
        fabric: elem.dataset.popupItemFabric ? elem.dataset.popupItemFabric : 'false',
        fromorder: elem.dataset.popupItemFromorderTranslate ? elem.dataset.popupItemFromorderTranslate : null,
      }
      if(elem.dataset.properties){
        if( typeof elem.dataset.properties == 'string'){
          variables.item.properties = {};
          Object.values(JSON.parse(elem.dataset.properties)).forEach((properti)=>{
            variables.item.properties[properti[0]] = properti[1];
          })
          
        }else if(typeof elem.dataset.properties == 'object'){
          variables.item.properties = elem.dataset.properties
        }else{
          variables.item.properties = {};
        }
      }else{
        variables.item.properties = {};
      }
      
      
      ChangeItemCartPopup(variables)
    })
  });


getShopCart().then((cart)=>{
  const cart_token = cart.token.split("?");
  clearTimeout(timeoutCartTimerinit);
  timeoutCartTimerinit = setTimeout(CartTimerinit(cart_token[0]), 300);  
})
  
}

function getTimeRemaining(endtime){  
  var t =  endtime - Date.parse(new Date());  
  
  var seconds = Math.floor( (t/1000) % 60 );  
  var minutes = Math.floor( (t/1000/60) % 60 );  
  var hours = Math.floor( (t/(1000*60*60)) % 24 );  
  var days = Math.floor( t/(1000*60*60*24) );  
  return {  
   'total': t,  
   'days': days,  
   'hours': hours,  
   'minutes': minutes,  
   'seconds': seconds  
  };  
}

function CartItemSetTimer(variant_id, expire_time){
  
  const CartItem = document.querySelector('[data-item-variantid="'+variant_id+'"]');
  
  if(!Boolean(CartItem)){
    setTimeout(()=>{
    CartItemSetTimer(variant_id, expire_time);
    }, 1000)
    return;
  }
  
  const CartItemReserv = CartItem.querySelector('.CartInnerContentItemInReserv');
  const CartItemReservText = CartItem.querySelector('[cart-item-reserv-text]');
  
    var t = getTimeRemaining(expire_time);

      if(t.total > 0){
        CartItemReserv.classList.add('hasTimer');
      }

      let hours_text = t.hours + ' ' + CartItemReservText.dataset.tHours
      if(t.hours < 2){
        hours_text = t.hours + ' ' + CartItemReservText.dataset.tHour
      }

      let minutes_text = t.minutes + ' ' + CartItemReservText.dataset.tMinutes
      if(t.minutes < 2){
        minutes_text = t.minutes + ' ' + CartItemReservText.dataset.tMinute
      }

      let seconds_text = t.seconds + ' ' + CartItemReservText.dataset.tSeconds
      if(t.seconds < 2){
        seconds_text = t.seconds + ' ' + CartItemReservText.dataset.tSecond
      }

      
      if(t.hours > 0){
        CartItemReservText.innerHTML = CartItemReservText.dataset.tIn_reserv + ' ' + hours_text + ' ' + minutes_text + ' ' + seconds_text ;  
      }else if(t.minutes > 0){
        CartItemReservText.innerHTML = CartItemReservText.dataset.tIn_reserv + ' ' + minutes_text + ' ' + seconds_text ;  
      }else{
        CartItemReservText.innerHTML = CartItemReservText.dataset.tIn_reserv + ' ' + seconds_text ;
      }
  
    var timeinterval = setInterval(function(){  
      
      var t = getTimeRemaining(expire_time);  
      if(t.total > 0){
        CartItemReserv.classList.add('hasTimer');
      }

      let hours_text = t.hours + ' ' + CartItemReservText.dataset.tHours
      if(t.hours == 1){
        hours_text = t.hours + ' ' + CartItemReservText.dataset.tHour
      }

      let minutes_text = t.minutes + ' ' + CartItemReservText.dataset.tMinutes
      if(t.minutes == 1){
        minutes_text = t.minutes + ' ' + CartItemReservText.dataset.tMinute
      }

      let seconds_text = t.seconds + ' ' + CartItemReservText.dataset.tSeconds
      if(t.seconds == 1){
        seconds_text = t.seconds + ' ' + CartItemReservText.dataset.tSecond
      }
      
      if(t.hours > 0){
        CartItemReservText.innerHTML = CartItemReservText.dataset.tIn_reserv + ' ' + hours_text + ' ' + minutes_text + ' ' + seconds_text ;  
      }else if(t.minutes > 0){
        CartItemReservText.innerHTML = CartItemReservText.dataset.tIn_reserv + ' ' + minutes_text + ' ' + seconds_text ;  
      }else{
        CartItemReservText.innerHTML = CartItemReservText.dataset.tIn_reserv + ' ' + seconds_text ;
      }
      
     if(t.total<=0){  
       getShopCart().then((cart)=>{
         const cart_token = cart.token.split("?");
        updateCartByReserv(cart_token[0]).then((new_cart)=>{
          document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
        })
        
       })

      clearInterval(timeinterval);  
     }  
    }, 1000);
  
}

function UpdateCartItemLenght(variant_id, available_product_length){
  const CartItem = document.querySelector('[data-item-variantid="'+variant_id+'"]');
  const CartItemChange = CartItem.querySelector('[cart-item-open-change]');
  
  if(!Boolean(CartItem) && !Boolean(CartItemChange)){
    setTimeout(()=>{
    UpdateCartItemLenght(variant_id, available_product_length);
    }, 500)
    return;
  }

  if(Boolean(CartItemChange)){
      if(Boolean(CartItemChange.dataset.popupItemLengthInOneHand) && Boolean(CartItemChange.dataset.popupItemLength) ){
        if(Number(CartItemChange.dataset.popupItemLength) + Number(available_product_length) < Number(CartItemChange.dataset.popupItemLengthInOneHand)){
        CartItemChange.dataset.popupItemAvailableLength = Number(available_product_length);
      }
    }else if(Boolean(CartItemChange.dataset.popupItemLength)){
        CartItemChange.dataset.popupItemAvailableLength = Number(available_product_length) + Number(CartItemChange.dataset.popupItemLength) ;
    }

    console.log(CartItemChange.dataset.popupItemAvailableLength)
  }
  
}


function CartTimerinit(cart_token){
  getAppCart(cart_token).then((app_cart)=>{
    if(app_cart.items){
      app_cart.items.forEach((item)=>{
        if(item.expire_time && item.expire_time !=='not_expire_time'){
          let expire_time = Date.parse(item.expire_time) + (Date.parse(new Date()) - Date.parse(app_cart.server_time));
          CartItemSetTimer(item.variant_id, expire_time)
        }
        if(Boolean(item.available_product_length)){
          UpdateCartItemLenght(item.variant_id, item.available_product_length)
        }
        
        
      })
    }
  })
}
let timeoutCartTimerinit;

document.addEventListener('UpdateCart', function(event){
  
})

document.addEventListener('DOMContentLoaded', () => {

  const cart = document.querySelector('#cart');
    
    let items = '';
    
    getShopCart()
    .then((data)=>{
      items = JSON.stringify(data.items);
    })
  
    document.addEventListener('UpdateCart', function(event){
      
    if( !Boolean(event.detail.cart.items) || JSON.stringify(event.detail.cart.items) !== items){
      let overflow_spinner = document.querySelector('[cart-overflow-spinner]');
      overflow_spinner.style.display = 'block';
        if(Boolean(event.detail.cart.items)){
          
        
        items = JSON.stringify(event.detail.cart.items);
        fetch('/cart')
        .then((response) => response.text() )
        .then(html => { 
          const parser = new DOMParser(); 
          const doc = parser.parseFromString(html, "text/html"); 

          if(cart.innerHTML !== doc.querySelector('#cart').innerHTML){
            cart.innerHTML = doc.querySelector('#cart').innerHTML;
            
           
            CartInit();
          }
          overflow_spinner.style.display = 'none';
        })
      }
    }
     
  });

CartInit();
  
  
})